module.exports = __webpack_public_path__ + "static/media/logo.44b8e7c4.png";